import { request } from "./httpClient";

function getUrl(prefixKey) {
  const prefix = (window.appConfig && window.appConfig[prefixKey]);
  return process.env.REACT_APP_API_URL + prefix;
}

export async function fetchCustomerByIdpId({ queryKey }) {
  const [, idpId, timeout] = queryKey;
  const url = `${getUrl("getCustomerDataUrl")}${idpId}`;
  return request(url, {}, timeout);
}

export async function updateSiteSteering({ queryKey }) {
  const [, siteId, preferenceId, timeout] = queryKey;
  const url = `${getUrl("updateSiteSteeringUrl")}${siteId}?steering_preference_id=${preferenceId}`;
  return request(url, { method: "PATCH" }, timeout);
}

export async function updateActiveSteeringPreference({ queryKey }) {
  const [, siteId, preferenceId, timeout] = queryKey;
  const url = `${getUrl("updateActiveSteeringPreferenceUrl")}${siteId}?steering_preference_id=${preferenceId}`;
  return request(
    url,
    {
      method: "PATCH"
    },
    timeout
  );
}

export async function updateSteeringPreference({ queryKey }) {
  const [, preferenceId, preference, timeout] = queryKey;
  const url = `${getUrl("updateSteeringPreferenceUrl")}${preferenceId}`;
  return request(
    url,
    {
      method: "PATCH",
      body: JSON.stringify(preference),
    },
    timeout
  );
}

export async function updateUser({ queryKey }) {
  const [, user_id, body, timeout] = queryKey;
  const url = `${getUrl("updateUserUrl")}${user_id}`;
  return request(
    url,
    {
      method: "PATCH",
      body: JSON.stringify(body),
    },
    timeout
  );
}

export async function updateCustomSchedule({ queryKey }) {
  const [, preferenceId, body, timeout] = queryKey;
  const url = `${getUrl("updateCustomScheduleUrl")}${preferenceId}`;
  return request(
    url,
    {
      method: "PATCH",
      body: JSON.stringify(body)
    },
    timeout
  );
}